import { Link } from 'react-router-dom';
import { HeartIcon } from '@heroicons/react/24/solid';
import { BellIcon } from '@heroicons/react/24/outline';
import { useAppSelector } from '../../../stores/store.ts';
import { selectUnreadNotificationsCount } from '../notification/accountNotificationsSelectors.ts';
import { selectIsAuth } from '../../auth/authSelectors.ts';

const AccountShortcutsPill = () => {
    const accountNotificationsUnreadCount = useAppSelector(selectUnreadNotificationsCount);
    const userIsAuth = useAppSelector(selectIsAuth);
    return (
        import.meta.env.VITE_BACKEND_TYPE === 'php' && userIsAuth &&
        <div
            className={'fixed flex gap-5 z-10 right-4 top-18 md:top-6 md:right-6 bg-neutral-600/50 border border-neutral-500 py-3 px-4 rounded-full z-20'}>
            <Link to={'/konto/ulubione'}><HeartIcon className={'w-8 h-8'} /></Link>
            <Link to={'/konto/powiadomienia'}>
                <div className={'relative'}><BellIcon className={'w-8 h-8'} />
                    <div
                        className={`absolute bg-blue-500 rounded-full  px-1.5 text-sm flex items-center -top-2 ${accountNotificationsUnreadCount > 10 ? "-right-2 " : "-right-0.5 aspect-square"}`}>{accountNotificationsUnreadCount}
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default AccountShortcutsPill;